import { render, staticRenderFns } from "./detail-info-item.vue?vue&type=template&id=0dfeae42&scoped=true&"
import script from "./detail-info-item.vue?vue&type=script&lang=js&"
export * from "./detail-info-item.vue?vue&type=script&lang=js&"
import style0 from "./detail-info-item.vue?vue&type=style&index=0&id=0dfeae42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfeae42",
  null
  
)

export default component.exports